import React from 'react'
import { MyHighlightedText } from './HighlightedText.styles'

export interface HighlightedTextProps {
    props: {
        title: string
        subtitle: string
        text: string
    }
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({props}) => {    
    return(
        <MyHighlightedText.Section>
            <MyHighlightedText.Wrapper>
                <MyHighlightedText.Header>
                    <MyHighlightedText.Title>{props.title}</MyHighlightedText.Title>
                    <MyHighlightedText.Subtitle>{props.subtitle}</MyHighlightedText.Subtitle>
                </MyHighlightedText.Header>
                <MyHighlightedText.Text>{props.text}</MyHighlightedText.Text>
            </MyHighlightedText.Wrapper>
        </MyHighlightedText.Section>
    )
}
